import { render, staticRenderFns } from "./ProjectLanding.vue?vue&type=template&id=5ccc4a08&lang=pug&"
import script from "./ProjectLanding.vue?vue&type=script&lang=js&"
export * from "./ProjectLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports